import React, { useState, useEffect } from 'react';
import useDynamicRefs from 'use-dynamic-refs';
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import '../../sass/components/flexibleModules/_components.repeaterFieldWithStickyNavigation.scss';
// import { useRive, Layout, Fit } from '@rive-app/react-canvas';
// import riveAnimae from '../../../static/3621-7569-searh-icon.riv';
// import Rive from '@rive-app/react-canvas';

const scrollToRef = (ref) => window.scrollTo({
    top: ref.current.offsetTop - 100,
    left: 0,
    behavior: 'smooth'
});

const RepeaterFieldWithStickyNavigation = ({ data, formId, ctaOverride }) => {
    const [getRef, setRef] = useDynamicRefs();
    const executeScroll = (index) => scrollToRef(getRef(index));

    //   const { rive, RiveComponent } = useRive({
    //     src: riveAnimae,
    //     autoplay: false,
    //     layout: new Layout({ fit: Fit.Cover })
    //   });

    //   function onMouseEnter() {
    //     if (rive) {
    //       rive.play();
    //     }
    //   }

    //   function onMouseLeave() {
    //     if (rive) {
    //       rive.pause();
    //     }
    //   }    

    /* marketo */
    const marketoScriptId = `mktoForms-${formId}`;
    const [isLoaded, setIsLoaded] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    var invalidDomains = ["@test.", "@1033edge.", "@11mail.", "@123.", "@123box.", "@123india.", "@123mail."];
    const [unlockItem, setUnlockItem] = useState(false);

    const unlock = (val) => {
        setUnlockItem(val);
    }

    useEffect(() => {
        if (!document.getElementById(marketoScriptId)) {
            {
                !isLoaded &&
                    loadScript();
            }
        } else {
            setIsLoaded(true);
        }

    }, []);

    useEffect(() => {
        {
            isLoaded &&
                window.MktoForms2.loadForm(
                    '//marketing.planful.com',
                    "323-LTC-321",
                    formId, function (form) {
                        form.onSuccess((values) => {
                            setIsSubmitted(true);
                            return false;
                        });
                        form.onValidate(function () {
                            var email = form.vals().Email;
                            if (email) {
                                if (!isEmailGood(email)) {
                                    form.submitable(false);
                                    var emailElem = form.getFormElem().find("#Email");
                                    if(process.env.GATSBY_LANG === "de"){
                                        form.showErrorMessage("Muss eine geschäftliche E-Mail-Adresse sein", emailElem);
                                    }
                                    else{
                                        form.showErrorMessage("Must be Business email.", emailElem);
                                    }
                                } else {
                                    form.submitable(true);
                                }
                            }
                        });
                    }
                );
        }
    }, [isLoaded, formId]);

    const isEmailGood = (email) => {
        for (var i = 0; i < invalidDomains.length; i++) {
            var domain = invalidDomains[i];
            if (email.indexOf(domain) !== -1) {
                return false;
            }
        }
        return true;
    }

    const loadScript = () => {
        var s = document.createElement('script');
        s.id = marketoScriptId;
        s.type = 'text/javascript';
        s.async = true;
        s.src = '//marketing.planful.com/js/forms2/js/forms2.min.js';
        s.onreadystatechange = function () {
            if (this.readyState === 'complete' || this.readyState === 'loaded') {
                setIsLoaded(true);
            }
        };
        s.onload = () => {
            setIsLoaded(true);
        }
        document.getElementsByTagName('head')[0].appendChild(s);
        let formSelect = `#mktoForm_${formId} .mktoButton`;
        setTimeout(() => {
            if (ctaOverride && document.querySelector('.mktoButton')) {
                document.querySelector(formSelect).innerHTML = ctaOverride;
            }
        }, 4000);
        // Adding Script for Marketo forms
        var formScript = document.createElement('script');
        formScript.innerHTML = function uet_report_conversion() { window.uetq = window.uetq || []; window.uetq.push('event', '', { "event_category": "Marketo Form New Site" }); }
        document.getElementsByTagName('head')[0].appendChild(formScript);
    };

    /* Marketo */

    return (
        <div className={`cp-flexibleRepeaterFieldWithStickyNavigation l--genericpadding l--sectionPadding ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-flexibleRepeaterFieldWithStickyNavigation__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <h1>{data.slug}</h1>
                {/* <Rive className="base-canvas-size" src={riveAnimae} /> */}
                {/* <RiveComponent key="1" className="base-canvas-size" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} /> */}
                <div className="cp-blogIndividual__mainContent l--flex l--maxWidthContentSmall" style={{ display: data.repeaterFieldSections === null ? 'none' : 'flex' }}>
                    <div className="cp-blogIndividual__mainContent-left">
                        <div className="cp-blogIndividual__mainContent-links">
                            {data.repeaterFieldSections &&
                                <>
                                    {data.repeaterFieldSections.map((fieldItems, index) => (
                                        <React.Fragment key={index}>
                                            <button onClick={() => executeScroll(`elemid-${index}`)} className={`cp-blogScrollSections ${fieldItems.repeaterFieldSectionSubHeader ? "l-subhead" : "l-head"}`} data-anchor={`cp-blogScrollSection-${index}`}>{fieldItems.repeaterFieldSectionSubHeader ? fieldItems.repeaterFieldSectionSubHeader : fieldItems.repeaterFieldSectionHeader}</button>
                                        </React.Fragment>
                                    ))}
                                </>
                            }
                        </div>
                        <div className="cp-blogIndividual__mainContent-social">
                            <div className="cp-footer__bottom-social l--social l--flex">
                                <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                                    <StaticImage src='../../images/Social icon.svg' alt="LinkedIn" />
                                </a>
                                <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                                    <StaticImage src='../../images/Social icon-1.svg' alt="Instagram" />
                                </a>
                                <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                                    <StaticImage src='../../images/Social icon-2.svg' alt="Twitter" />
                                </a>
                                <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                                    <StaticImage src='../../images/Social icon-3.svg' alt="Facebook" />
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="cp-blogIndividual__mainContent-right">
                        {data.repeaterFieldSections &&
                            <>
                                {data.repeaterFieldSections.map((fieldItems, index) => (
                                    <div ref={setRef(`elemid-${index}`)} key={index} className={`cp-blogScrollSections cp-blogScrollSection-${index}`} >
                                        {fieldItems.repeaterFieldSectionContent &&
                                            <>
                                                {/* {fieldItems.repeaterFieldSectionHeader &&
                                                    <h2>{fieldItems.repeaterFieldSectionHeader}</h2>
                                                } */}
                                                {fieldItems.repeaterFieldSectionContent.map((flexiItem, index) => (
                                                    <React.Fragment key={index}>
                                                        {flexiItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_RichContent' &&
                                                            <div className={`cp-flexiRichContent l--genericSpacingSmall ${flexiItem.overrideClassRichContent}`} style={{ backgroundColor: flexiItem.backgroundColorRichContent }} dangerouslySetInnerHTML={{ __html: flexiItem.richContentField }} />
                                                        }
                                                        {flexiItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_ImageContent' &&
                                                            <div className="cp-flexiImageContent l--genericSpacingSmall l--centerAlign">
                                                                {flexiItem.imageContentField &&
                                                                    <GatsbyImage className="l--borderRadiusLarge" image={getImage(flexiItem.imageContentField.gatsbyImage)} alt={flexiItem.imageContentField.altText} />
                                                                }
                                                                <span>{flexiItem.imageContentCourtesy}</span>
                                                            </div>
                                                        }
                                                        {flexiItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_QuoteSection' &&
                                                            <div className="cp-flexiQuoteContent l--genericSpacingSmall">
                                                                <h3>{flexiItem.quoteSectionField}</h3>
                                                                <span className="l-author">{flexiItem.quoteSectionFieldAuthor}</span>
                                                                {flexiItem.quoteSectionFieldLink &&
                                                                    <a href={flexiItem.quoteSectionFieldLink.url} target={flexiItem.quoteSectionFieldLink.target} className="l-textlink">
                                                                        <span>{flexiItem.quoteSectionFieldLink.title}</span>
                                                                        <StaticImage src="../../images/arrow-pro-right.svg" alt="" />
                                                                    </a>
                                                                }
                                                            </div>
                                                        }
                                                        {flexiItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_ContentGrid' &&
                                                            <div className="cp-flexiContentGrid l--genericSpacingSmall" style={{ backgroundColor: `${flexiItem.contentGridBackground}` }}>
                                                                {flexiItem.contentGridRepeater &&
                                                                    <>
                                                                        {flexiItem.contentGridRepeater.map((gridSections, index) => (
                                                                            <div className={`cp-flexiContentGrid__sections l-layoutGrid${gridSections.contentGridRepeaterMainLayout}`} key={index}>
                                                                                {gridSections.contentGridRepeaterMainHeader &&
                                                                                    <h2>{gridSections.contentGridRepeaterMainHeader}</h2>
                                                                                }
                                                                                {gridSections.contentGridRepeaterMainSections &&
                                                                                    <div className="l--flex">
                                                                                        {gridSections.contentGridRepeaterMainSections.map((grids, index) => (
                                                                                            <div className="cp-flexiContentGrid__sections-content" key={index}>
                                                                                                {grids.icon &&
                                                                                                    <GatsbyImage image={getImage(grids.icon.gatsbyImage)} alt={grids.icon.altText} />
                                                                                                }
                                                                                                <p>
                                                                                                    {grids.header &&
                                                                                                        <span>{grids.header}</span>
                                                                                                    }
                                                                                                    {grids.teaser &&
                                                                                                        <span>{grids.teaser}</span>
                                                                                                    }
                                                                                                </p>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                        ))}
                                                                    </>
                                                                }
                                                            </div>
                                                        }
                                                        {flexiItem.__typename === 'WordpressPage_Modularflexiblefields_ModularFields_RepeaterFieldWithStickyNavigation_repeaterFieldSections_RepeaterFieldSectionContent_HalfAndHalfSectionWithMarketoForm' &&
                                                            <div className="cp-halfSectionMarkeoForm l--flex">
                                                                <div className="cp-halfSectionMarkeoForm__left">
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormImage &&
                                                                        <GatsbyImage className="l--borderRadiusLarge" image={getImage(flexiItem.halfAndHalfSectionWithMarketoFormImage.gatsbyImage)} alt={flexiItem.halfAndHalfSectionWithMarketoFormImage.altText} />
                                                                    }
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormContent &&
                                                                        <div className="l--content" dangerouslySetInnerHTML={{ __html: flexiItem.halfAndHalfSectionWithMarketoFormContent }} />
                                                                    }
                                                                </div>
                                                                <div className="cp-halfSectionMarkeoForm__right">
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormHeader &&
                                                                        <h2>{flexiItem.halfAndHalfSectionWithMarketoFormHeader}</h2>
                                                                    }
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormRightContent &&
                                                                        <div dangerouslySetInnerHTML={{ __html: flexiItem.halfAndHalfSectionWithMarketoFormRightContent }} />
                                                                    }
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormAwardsHeader &&
                                                                        <h3>{flexiItem.halfAndHalfSectionWithMarketoFormAwardsHeader}</h3>
                                                                    }
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormAwardsLogos &&
                                                                        <div className="l-awardlogos l--flex">
                                                                            {flexiItem.halfAndHalfSectionWithMarketoFormAwardsLogos.map((logo, index) => (
                                                                                <GatsbyImage image={getImage(logo.gatsbyImage)} alt={logo.altText} key={index} />
                                                                            ))}
                                                                        </div>
                                                                    }
                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormMarketoReport === 'yes' &&
                                                                        <>
                                                                            {!isSubmitted &&
                                                                                <button className="l--flex" onClick={() => unlock(true)}>
                                                                                    {/* <RiveComponent key={index} className="base-canvas-size" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} /> */}
                                                                                    {/* <RiveComponent className="base-canvas-size" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} /> */}
                                                                                    {/* <Rive layout={new Layout({ fit: Fit.Contain, alignment: Alignment.TopCenter })} src={riveAnimae} /> */}
                                                                                    <span>Unlock</span>
                                                                                    <span className="l-hoverParent">
                                                                                        <StaticImage className="l-nohover" src='../../images/lock-icon.svg' alt="submit form to unlock" />
                                                                                        <StaticImage className="l-hover" src='../../images/lock-icon-close.svg' alt="submit form to unlock" />
                                                                                    </span>
                                                                                    <span className="l-rightSpan">Report</span>
                                                                                </button>
                                                                            }
                                                                            {isSubmitted &&
                                                                                <>
                                                                                    {
                                                                                        flexiItem.halfAndHalfSectionWithMarketoFormLink &&
                                                                                        <a className="l-button" href={flexiItem.halfAndHalfSectionWithMarketoFormLink.url} target={flexiItem.halfAndHalfSectionWithMarketoFormLink.target}>{flexiItem.halfAndHalfSectionWithMarketoFormLink.title}</a>
                                                                                    }
                                                                                    {flexiItem.halfAndHalfSectionWithMarketoFormPdf &&
                                                                                        <a className="l-button" href={flexiItem.halfAndHalfSectionWithMarketoFormPdf.link} target="_blank" rel="noreferrer">Download Now</a>
                                                                                    }
                                                                                </>
                                                                            }
                                                                        </>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </React.Fragment>
                                                ))}
                                            </>
                                        }
                                    </div>
                                ))}
                            </>
                        }
                    </div>
                </div>
                {!isSubmitted &&
                    <div className={`l--formpopup ${unlockItem ? "l-showForm" : "l-hideForm"}`}>
                        <div className="l--formpopup__inner">
                            <form id={`mktoForm_${formId}`}></form>
                            <button className="cp-formpopup__close" onClick={() => unlock(false)}>
                                <StaticImage src="../../images/cross-Icon.svg" alt=""></StaticImage>
                            </button>
                        </div>
                        <button className="l-formpopupClose" onClick={() => unlock(false)}></button>
                    </div>
                }
            </div>
        </div>
    );
}

export default RepeaterFieldWithStickyNavigation;